export interface Role {
  _id: string;
  name: string;
  description: string;
  roleType: RoleType;
  modules: number[];
}

export enum RoleType {
  Admin = "admin",
  Member = "member",
  TokenRole = "token",
}

export interface CreateRoleDto {
  name: string;
  description: string;
  roleType: RoleType;
  modules: number[];
}

export interface Module {
  id: number;
  name: string;
}
